module.exports = __webpack_public_path__ + "static/img/homeBg.874caf3f.png";